import { render, staticRenderFns } from "./WorkshopFacilitatorUpdateCpt.vue?vue&type=template&id=1a7f972a&scoped=true&"
import script from "./WorkshopFacilitatorUpdateCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopFacilitatorUpdateCpt.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopFacilitatorUpdateCpt.vue?vue&type=style&index=0&id=1a7f972a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f972a",
  null
  
)

export default component.exports